export default function fitInRangeAndStep(value, _ref) {
  var step = _ref.step,
    min = _ref.min,
    max = _ref.max,
    defaultValue = _ref.defaultValue;
  // eslint-disable-line
  if ((typeof value !== 'number' || isNaN(value)) && typeof defaultValue === 'number') return defaultValue;
  var inInterval = Math.max(min, Math.min(max, parseInt(value, 10)));
  return Math.round((inInterval - min) / step) * step + min;
}